import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of, tap, switchMap } from 'rxjs';
import * as discussionActions from '../actions/discussion.actions';
import { Store } from '@ngrx/store';
import { DiscussionService } from '../../services/discussion.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class DiscussionsEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private discussionService: DiscussionService,
    private messageService: MessageService
  ) {}

  loadDiscussions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(discussionActions.loadDiscussionByRule),
      switchMap(({ ruleUid }) => {
        return this.discussionService.GetByRuleUid(ruleUid).pipe(
          map((discussion) =>
            discussionActions.loadDiscussionSuccess({ discussion })
          ),
          catchError((error) =>
            of(discussionActions.loadDiscussionFailure({ error }))
          )
        );
      })
    )
  );

  loadDiscussionWithMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(discussionActions.loadDiscussionWithMessagesByUid),
      mergeMap(({ discussionUid }) => {
        return this.discussionService.GetWithMessagesByUid(discussionUid).pipe(
          map((discussion) => {
            return discussionActions.loadDiscussionSuccess({ discussion });
          }),
          catchError((error) =>
            of(discussionActions.loadDiscussionFailure({ error }))
          )
        );
      })
    )
  );

  addMessageToDiscussion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(discussionActions.addMessageToDiscussion),
      mergeMap(({ discussionMessage }) => {
        return this.discussionService
          .AddDiscussionMessage(discussionMessage)
          .pipe(
            map((discussionMessage) =>
              discussionActions.addMessageToDiscussionSuccess({
                discussionMessage,
              })
            ),
            catchError((error) =>
              of(discussionActions.addMessageToDiscussionFailure({ error }))
            )
          );
      })
    )
  );

addMessageToDiscussionSuccess$ = createEffect(() =>
  this.actions$.pipe(
    ofType(discussionActions.addMessageToDiscussionSuccess),
    tap(() => {
      this.messageService.add({
        
        severity: 'success',
        summary: 'Succès',
        detail: 'Le message a été envoyé avec succès',
      });
    }),
    map(action =>
      {
        return discussionActions.loadDiscussionWithMessagesByUid({ discussionUid: action.discussionMessage?.discussion_FK })}
    )
  )
);

  addMessageToDiscussionFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(discussionActions.addMessageToDiscussionFailure),
        tap(({ error }) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: "L'envoi du message a échoué",
          });
        })
      ),
    { dispatch: false }
  );
}
